// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import AddTeam from '../addTeam';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import AddMember from '../addTournamentTeamMember';
import Dialog from 'material-ui/Dialog';
import EditTournamentTeam from '../editTournamentTeam';

class ViewCompetitionTeam extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.id,
      competition_id:props.competition_id,
      teams: [],
      groups: [],
      game_types: [],
      team_list :[],
      age_groups:[],
      tournament_team_details: {
        tournament_id: props.id,
        competition_id:props.competition_id,
        name: '',
        group: '',
        game_type:'',
        logo:'',
        jersey:'',
        age_group:'',
        amount_paid:0,
      },
      team_name:'',
      team_id:'',
      addMemberView:false,
      data_uploaded: false,
      data_error: false,
      addNewTeamView:false,
      editTeamView:false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFileLogo = this.handleFileLogo.bind(this);
    this.handleFileJersey = this.handleFileJersey.bind(this);
    this.getTeamList = this.getTeamList.bind(this);

  }


  componentDidMount() {
    this.getaddTeamInputs();
    this.getTeamList();
    this.getTeamDetailInput();
    console.log(this.state);
  }
  getTeamDetailInput() {
     const url = `${getLocationOrigin()}/eagleeye/get_inputs_for_add_tournament_team/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
         this.setState({ teams: data.teams, groups: data.groups,age_groups:data.age_groups});
        })
       .catch(error => error);
  } 

  getaddTeamInputs() {
     const url = `${getLocationOrigin()}/eagleeye/get_inputs_for_add_team/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
         this.setState({game_types: data.game_types});
        })
       .catch(error => error);
  }
  postaddTournamentTeam(data, props) {
    
    console.log('postaddTournamentTeam')
    if(data.name == '' || data.logo == '' || data.jersey == ''){alert('All fields are mandatory')}
    else{
      if(data.group == ''){data.group=this.state.groups[0]}
      if(data.game_type == ''){data.game_type=this.state.game_types[0].pk}
      if(data.age_group == ''){data.age_group=this.state.age_groups[0].id}
      console.log(data)
      const url = `${getLocationOrigin()}/eagleeye/create_tournament_team/`;
      const options = {...defaultOptions};
      var formData = new FormData();
      for(var name in data) {
        formData.append(name, data[name]);
      }
      options['method'] = 'post';
      options['body'] = formData;
      console.log('Going to fetch');
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then((response) => {                      // first then()
            alert(response.message);
            this.getTeamList();
            this.toAddTeamView();
            
          })
        .catch(error => {
          console.log(error);
          alert(error.message);
        });
    }
  }

  getTeamList() {
        var mobile_no = this.state.mobile_no
        const url = `${getLocationOrigin()}/eagleeye/get_tournament_teams_details/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                             'competition_id': this.state.competition_id
                           });
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => this.setState({team_list: data.teamlist}))
           .catch(error => {
             console.log(error);
             alert(error.message);
           });
    }



  handleChange(event) {
    const name = event.target.name;
    console.log(event.target.name,event.target.value)
    var new_selected_one =  Object.assign({}, this.state.tournament_team_details);
    new_selected_one[name] = event.target.value
    this.setState({tournament_team_details: new_selected_one});
  }
  handleFileLogo(selectorFiles: FileList){
    var new_selected_one =  Object.assign({}, this.state.tournament_team_details);
    console.log('Fileeeee');
    console.log(selectorFiles);
    new_selected_one['logo'] = selectorFiles[0]
    this.setState({tournament_team_details: new_selected_one});
  }
  toAddPlayerView(team){
    console.log(team.team.id,team.team.name)
    this.setState({team_name:team.team.name,team_id:team.team.id,addMemberView:!this.state.addMemberView})
  }

  handleFileJersey(selectorFiles: FileList){
    var new_selected_one =  Object.assign({}, this.state.tournament_team_details);
    console.log('Fileeeee');
    console.log(selectorFiles);
    new_selected_one['jersey'] = selectorFiles[0]
    this.setState({tournament_team_details: new_selected_one});
  }
  handleSubmit(event) {
    event.preventDefault();
    this.postaddTournamentTeam(this.state.tournament_team_details, this.props);
    console.log('post');
    console.log(this.state);
  }
  toAddTeamView(){
    this.setState({addNewTeamView:!this.state.addNewTeamView});
    this.getTeamList();
  }
  toEditTeamView(){
    this.setState({editTeamView:!this.state.editTeamView});
    this.getTeamList();
  }

  render() {
    console.log('Teams')
    console.log(this.state)
    return(

      <div className="col-md-12" style={{padding:'1%'}}>          
          { this.state.team_list.length > 0 && 
            <div className="col-md-12" style={styles.table} >
                 <div className="heading2" style={styles.sub_header}> Teams </div> 
                <table className="table_plain" >
                          <tr>
                                <th>Name </th>
                                <th>Category </th>
                                <th>Group </th>
                                <th>Amount Paid </th>
                                <th>Players </th>
                                <th>Action </th>
                          </tr>                   
                      { this.state.team_list.map((team,index) =>
                      <tr key={index}>
                        <td> {team.team.name} </td>
                        <td>{team.age_groups && team.age_groups.name}</td>
                        <td>{team.group}</td>
                        <td>{team.amount_paid} </td>
                        <td>{team.no_of_players} </td>
                        <td style={{fontSize:'25px'}}><i className="far fa fa-user-plus" onClick={() => {this.toAddPlayerView(team)}} />
                        <a href={`../../#/crud/editCompetitionTeam/${team.id}`} title="Edit" class="x1"><i className="far fa fa-edit"  style={{marginLeft:'10%'}}></i></a>
                        <a href={`../../#/crud/deleteCompetitionTeam/${team.id}`} title="delete" class="x1">
                            <i className="far fa fa-trash" style={{fontSize:'30px',paddingLeft:'10%'}} />          
                         </a>
                        </td>
                      </tr>
                      )}
                      </table>
            </div>
        }
        {this.state.addMemberView && 
          <div className="col-md-12">
              <AddMember team_id={this.state.team_id}  team_name={this.state.team_name} tournament_id={this.state.tournament_team_details.tournament_id}/>
          </div>
        }
      </div>
    );
  }
}

export default ViewCompetitionTeam;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/viewCompetitionTeam/index.js